import React from 'react';
import SvgIcon from '@material-ui/core/SvgIcon';
/**
 * RestoreZoomIcon ~
*/

export default function RestoreZoomIcon(props) {
  return /*#__PURE__*/React.createElement(SvgIcon, props, /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: "24",
    height: "24",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6,15H9v3h2V13H6Zm9-6V6H13v5h5V9Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12,2A10,10,0,1,0,22,12,10,10,0,0,0,12,2Zm0,18a8,8,0,1,1,8-8,8,8,0,0,1-8,8Z"
  })));
}